"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crewUpdate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var imports_1 = require("@lib/imports");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_1 = require("@main/common");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var voyageMessageCrewCreate_1 = require("@voyage/multi/voyageMessageCrewCreate");
var voyageMessageCrewCreate_sidecar_1 = require("@voyage/multi/voyageMessageCrewCreate-sidecar");
var voyageMessageEffectCommand_1 = require("@voyage/multi/voyageMessageEffectCommand");
var voyageMessageEffectCommand_sidecar_1 = require("@voyage/multi/voyageMessageEffectCommand-sidecar");
var voyageMessageHostCommand_1 = require("@voyage/multi/voyageMessageHostCommand");
var voyageMessageHostCommand_sidecar_1 = require("@voyage/multi/voyageMessageHostCommand-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageSystems_sidecar_1 = require("@voyage/systems/voyageSystems-sidecar");
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    var useSystemTime = 3;
    d.useSystemTimer += ds;
    diveCrew_hero_sidecar_1.diveCrew_hero.setProgress(obj, d.useSystemTimer / useSystemTime);
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        if (voyageSystems_sidecar_1.voyageSystems.testNoPower(obj)) {
            return;
        }
        var bodies = imports_1.l.filter(diveCrew_sidecar_1.diveCrew.getAll(), function (c) {
            if (!(c.type === diveCrew_1.EVoyageCrewType.Hero || c.type === diveCrew_1.EVoyageCrewType.Enemy)) {
                return false;
            }
            if (!c.isDying) {
                return;
            }
            return true;
        });
        if (bodies.length > 0) {
            if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                var cr = rando_sidecar_1.rando.sample(bodies);
                // let fire = diveCrew.create(EVoyageCrewType.Fire, -1)
                // diveCrew.moveToIJ(fire, cr)
                voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
                    crewId: common_1.createId(),
                    i: cr.i,
                    j: cr.j,
                    method: voyageMessageCrewCreate_1.EVoyageCrewCreateMethod.Normal,
                    team: -1,
                    type: diveCrew_1.EVoyageCrewType.Fire,
                    heroType: diveCrew_hero_data_1.EDiveHeroSubtype.None,
                    enemyType: '',
                    energy: 0,
                    hitpoints: 15,
                });
                // diveCrew.kill(cr)
                voyageMessageHostCommand_sidecar_1.voyageMessageHostCommand.sendMessageAndImmediatelyExecute({
                    command: voyageMessageHostCommand_1.EHostCommand.old_DestroyCrew,
                    crewId: cr.id,
                });
                // voyageSounds.playExplosionFire()
                voyageMessageEffectCommand_sidecar_1.voyageMessageEffectCommand.sendMessageAndImmediatelyExecute({
                    command: voyageMessageEffectCommand_1.EEffectCommand.HitFire,
                });
            }
        }
    }
}
exports.crewUpdate = crewUpdate;
